<div class="h-100 d-flex flex-column justify-content-between">  
    <div class="py-1 pl-2 d-flex flex-row justify-content-between modal-header">
       <app-scout-header [scoutTaskDoc]="task" [scoutPoint]="point" [scoutPath]="path" ></app-scout-header>
       <i class="pr-2 fa fa-times" role="button" (click)="onCloseModal()"></i>         
    </div>
    <div class="py-0 px-2">
        <app-scout-point-photo-editor #editor            
            [scoutTaskDoc]="task" 
            [scoutPathId]="path.id"
            [scoutPoint]="point"
            [scoutPhoto]="photo"
            [groupName]="photo.group"
            [editableDescription]="true"
            [editableTitle]="['point-to-point','additional'].includes(photo?.group)"
            [photoClickHandler]="onPhotoClick"
            [moveEnabled]="false"
            [deleteEnabled]="false"
            (saved)="init()"
            [readOnly]="locked"
        ></app-scout-point-photo-editor>
    </div>
    <div class="p-3 d-flex flex-row justify-content-between modal-footer">
      <div class="d-flex flex-row">
          <div class="pr-1 text-right" style="width:1em;">
              <a *ngIf="index > 0 && !editor?.bSaving" href="javascript:false;" role="button" 
                (click)="onNextPhoto(-1)"><i class="fa fa-chevron-left small"></i></a>
          </div>
          <div class="font-italic text-center text-nowrap" style="font-size:18px;width:10em;">
            {{groupTitle}} <ng-container *ngIf="index>=0">#{{groupIndex+1}} of {{groupSize}}</ng-container>
          </div>
          <div class="pl-1 text-left" style="width:1em;">
              <a *ngIf="index != -1 && (index + 1 < photos?.length) && !editor?.bSaving" href="javascript:false;" role="button" 
                (click)="onNextPhoto(1)"><i class="fa fa-chevron-right small"></i></a>
          </div>
      </div>        
      <div>
        <button *ngIf="!locked&&(!editor.isEditing&&photo?._id)" (click)="editor.isEditing = true;" class="btn btn-secondary btn-sm">Edit</button>
        <button *ngIf="!locked&&(editor.photoForm?.dirty||!photo?._id)" (click)="onSave()" [disabled]="editor?.bSaving" class="ml-2 btn btn-primary btn-sm">Save</button>
        <button (click)="onCloseModal()" class="ml-2 btn btn-primary btn-sm">Close</button>
      </div>
    </div>
</div>